module.exports = __webpack_public_path__ + "bin/e774aa1f71a10de6302841e810f18563.jpg";